console.log('porttimingcalc.js LOADED');

function GetDegrees(){
var top = document.TimingCalc.PortHeight.value*1.0;
var rod = document.TimingCalc.RodLength.value*1.0;
var str = document.TimingCalc.Stroke.value*1.0;
 
var vc1 = top*(top+2*rod);
var vc3 = rod+ top-str*0.5;
 
var result = Math.acos(1-((vc1)/(str*(vc3))))*360/Math.PI;
document.TimingCalc.PortTiming.value = (Math.round(result*100)/100).toFixed(1);
return 1;
}
 
function GetHeight(){
var hei = document.TimingCalc.PortTiming.value*1.0;
var rod = document.TimingCalc.RodLength.value*1.0;
var str = document.TimingCalc.Stroke.value*1.0;
 
var vc1 = 1-Math.cos(hei*Math.PI/360);
var vc2 = str/2*Math.sin(hei*Math.PI/360)/rod;
var vc3 = rod*(1-Math.cos(Math.asin(vc2)));
 
var result = str/2*(vc1)-vc3;
document.TimingCalc.PortHeight.value = (Math.round(result*10000)/10000).toFixed(1);
}